import { RootState } from 'slices';

export const publicSelector = {
  getPublic: (state: RootState) => state.public,
};
